import React from 'react'

function My_Account() {
  return (
    <div>My_Account</div>
  )
}

export default My_Account